import API_ENDPOINTS from "../components/config/apiConfig";
import { getFirebaseToken } from "../utils/auth";

async function getAuthToken() {
  return await getFirebaseToken();
}

/**
 * Fetch leads (user interactions) for a given service provider.
 * Returns the responseData array on success, or an empty array on failure.
 */
export async function getLeadsBySpId(spId) {
  try {
    const token = await getAuthToken();
    if (!token) throw new Error("Not authenticated");

    const response = await fetch(API_ENDPOINTS.GET_LEADS_BY_SP_ID(spId), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch leads: ${response.status}`);
    }

    const data = await response.json();
    if (data.responseCode === 200 && Array.isArray(data.responseData)) {
      return data.responseData;
    }
    return [];
  } catch (error) {
    console.error("Error fetching leads:", error);
    return [];
  }
}
